<template>
  <v-dialog v-model="dialogShown"
            persistent
            fullscreen
            content-class="login-dialog"
            transition="fade-transition">
    <v-container class="login">
      <v-row>
        <v-col>
          <v-img src="../assets/img.png"
                 height="100px"
                 max-height="200px"
                 contain></v-img>
        </v-col>
      </v-row>
      <v-row class="mb-4">
        <v-col class="text-h3 text-center font-weight-bold">
          {{ $t('title') }}
        </v-col>
      </v-row>

      <v-stepper v-model="step">
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card>
              <v-card-title class="justify-center">
                {{ $t('login.title') }}
              </v-card-title>
              <v-card-text class="text-center">
                <v-form ref="loginForm">
                  <v-text-field outlined
                                :label="$t('login.username')"
                                v-model="username"
                                :rules="requiredRules">
                  </v-text-field>
                  <v-row>
                    <v-col cols="8">
                      <v-text-field outlined
                                    :label="$t('login.otp')"
                                    v-model="otp"
                                    :rules="requiredRules">
                      </v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-btn block
                             x-large
                             color="primary"
                             :disabled="!username || otpResendAfterSeconds !== 0"
                             @click="getOtp">
                        {{
                          otpResendAfterSeconds === 0 ? $t('login.get_otp') : $t('login.otp_resend_countdown', {second: otpResendAfterSeconds})
                        }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-text-field outlined
                                :label="$t('login.password')"
                                v-model="password"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                                @click:append="showPassword = !showPassword"
                                @keyup.enter="login"
                                :rules="requiredRules">
                  </v-text-field>
                </v-form>
                <v-btn text
                       x-small
                       class='text-decoration-underline mb-4'
                       color="primary"
                       @click="step = 3">
                  {{ $t('login.forget_password') }}
                </v-btn>
                <v-btn block
                       color="primary"
                       dark
                       class="mb-4"
                       @click="$refs.loginForm.validate() && login()">
                  {{ $t('login.login') }}
                </v-btn>
                <v-btn block
                       color="primary"
                       dark
                       class="mb-4"
                       @click="$loginTeamNote()">
                  {{ $t('login.sso') }}
                </v-btn>
                <!--                <div>-->
                <!--                  <span>{{ $t('login.signup_1') }}</span>-->
                <!--                  <v-btn text-->
                <!--                         small-->
                <!--                         class='text-decoration-underline login-signup-btn'-->
                <!--                         color="primary"-->
                <!--                         @click="step = 2">-->
                <!--                    {{ $t('login.signup_2') }}-->
                <!--                  </v-btn>-->
                <!--                </div>-->
              </v-card-text>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card>
              <v-card-title class="justify-center">
                {{ $t('password_expired.title') }}

                <v-btn text
                       x-small
                       color="primary"
                       class="signup-back-btn"
                       @click="step = 1">
                  &lt;&lt; Back
                </v-btn>
              </v-card-title>
              <v-card-text class="text-center">
                <v-form ref="form">
                  <v-text-field outlined
                                :label="$t('password_expired.old_password')"
                                v-model="passwordExpired.old_password"
                                type="password"
                                :rules="requiredRules">
                  </v-text-field>
                  <v-text-field outlined
                                :label="$t('password_expired.new_password')"
                                v-model="passwordExpired.new_password"
                                type="password"
                                :rules="passwordRules">
                  </v-text-field>
                  <v-text-field outlined
                                :label="$t('password_expired.confirm_password')"
                                v-model="passwordExpired.confirm_password"
                                type="password"
                                :rules="reEnterPasswordRules">
                  </v-text-field>
                  <v-btn block
                         color="primary"
                         class="mb-4"
                         @click="$refs.form.validate() && submit()">
                    {{ $t('signup.signup') }}
                  </v-btn>

                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-card>
              <v-card-title class="justify-center">
                {{ $t('reset_password.title') }}

                <v-btn text
                       x-small
                       color="primary"
                       class="signup-back-btn"
                       @click="step = 1">
                  &lt;&lt; Back
                </v-btn>
              </v-card-title>
              <v-card-text class="text-center">
                <v-form ref="resetPasswordForm">
                  <v-text-field outlined
                                :label="$t('reset_password.username')"
                                v-model="resetPassword.username"
                                :rules="requiredRules">
                  </v-text-field>
                  <v-row>
                    <v-col cols="8">
                      <v-text-field outlined
                                    :label="$t('login.otp')"
                                    v-model="resetPassword.otp"
                                    :rules="requiredRules">
                      </v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-btn block
                             x-large
                             color="primary"
                             :disabled="!resetPassword.username || otpResendAfterSeconds !== 0"
                             @click="getOtp(true)">
                        {{
                          otpResendAfterSeconds === 0 ? $t('login.get_otp') : $t('login.otp_resend_countdown', {second: otpResendAfterSeconds})
                        }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-text-field outlined
                                :label="$t('reset_password.new_password')"
                                v-model="resetPassword.new_password"
                                type="password"
                                :rules="passwordRules">
                  </v-text-field>
                  <v-text-field outlined
                                :label="$t('reset_password.confirm_password')"
                                v-model="resetPassword.confirm_password"
                                type="password"
                                :rules="resetPasswordReEnterPasswordRules">
                  </v-text-field>
                  <v-btn block
                         color="primary"
                         class="mb-4"
                         @click="$refs.resetPasswordForm.validate() && submitResetPassword()">
                    {{ $t('reset_password.title') }}
                  </v-btn>

                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

      <div class="version">{{ version }}</div>
    </v-container>
  </v-dialog>
</template>

<script>
import {ref, watch} from '@vue/composition-api';
import {ACTION_TYPES} from "@/store/types";
import {DateTime} from 'luxon';

export default {
  name: 'LoginModal',
  props: {
    shown: Boolean,
  },
  setup(props, {root}) {
    const dialogShown = ref(props.shown);
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue && !oldValue) {
        username.value = '';
        otp.value = '';
        password.value = '';
        signup.value = {};
      }

      dialogShown.value = newValue;
    });

    const step = ref(1);

    const otp = ref('');
    const otpResendCountdownInterval = ref(null);
    const otpResendAfter = ref(null);
    const otpResendAfterSeconds = ref(0);
    const getOtp = async function (forgetPassword) {
      if (otpResendCountdownInterval.value) return

      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'get_otp/',
        params: {
          username: forgetPassword === true ? resetPassword.value.username : username.value,
        },
      });

      otpResendAfter.value = DateTime.fromISO(response.body.throttled_until);
      otpResendCountdownInterval.value = setInterval(() => {
        otpResendAfterSeconds.value = Math.ceil(otpResendAfter.value.diffNow('seconds').seconds);
        if (otpResendAfterSeconds.value === 0) {
          clearInterval(otpResendCountdownInterval.value);
          otpResendCountdownInterval.value = null;
        }
      }, 1000);
    }
    const clearOtpResendCountdown = function () {
      otpResendAfter.value = null;
      otpResendAfterSeconds.value = 0;
      if (otpResendCountdownInterval.value) {
        clearInterval(otpResendCountdownInterval.value);
        otpResendCountdownInterval.value = null;
      }
    }

    const username = ref('');
    const password = ref('');
    const showPassword = ref(false);
    const login = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.LOGIN, {
        username: username.value,
        password: password.value,
        otp: otp.value,
      });

      if (response.status !== 200) {
        if (response.status === 401 || response.status === 302) {
          root.$showAlertMessage(root.$t(`error_messages.access_denied`));
        } else if (typeof response.body === 'object') {
          if ('msg' in response.body) {
            let msg = response.body.msg;
            if (msg === 'password_expired') {
              step.value = 2;
              return;
            }

            if (root.$te('error_messages.' + msg)) {
              root.$showAlertMessage(root.$t(`error_messages.${msg}`));
              return;
            } else {
              root.$showAlertMessage(msg);
              return
            }
          }
          root.$showAlertMessage(root.$t('error_messages.default'));
          return
        }

        root.$showAlertMessage(root.$t('error_messages.default'));
      }
      password.value = '';
    };

    // Password Expired
    const passwordExpired = ref({});
    const passwordRules = ref([
      value => (!!value && value.length >= 8) || root.$t('signup.password_contain_eight_characters'),
      value => (!!value && !!value.match(/[A-Z]/g)) || root.$t('signup.password_contain_uppercase_letters'),
      value => (!!value && !!value.match(/[a-z]/g)) || root.$t('signup.password_contain_lowercase_letters'),
      value => (!!value && !!value.match(/[0-9]/g)) || root.$t('signup.password_contain_numbers'),
      value => (!!value && !!value.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g) && !value.match(/[ ]/g)) || root.$t('signup.password_contain_special_characters'),
    ]);
    const reEnterPasswordRules = ref([
      value => (!!value && value === passwordExpired.value.new_password) || root.$t('signup.password_mismatch')
    ]);

    // Reset Password
    const resetPassword = ref({});
    const resetPasswordReEnterPasswordRules = ref([
      value => (!!value && value === resetPassword.value.new_password) || root.$t('signup.password_mismatch')
    ]);
    const submitResetPassword = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'reset_password/',
        params: {
          ...resetPassword.value,
        },
      });

      if (response.body.success) {
        root.$showAlertMessage(root.$t('reset_password.success_msg'));
        password.value = null;
        otp.value = null;
        clearOtpResendCountdown()
        resetPassword.value = {};
        step.value = 1;
      }
    }

    const requiredRules = ref([
      value => !!value || root.$t('rules.required'),
    ]);
    const signup = ref({});
    const showSignupPassword = ref(false);
    const reEnterPassword = ref(null);
    const showSignupReEnterPassword = ref(false);

    const submit = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'change_password/',
        params: {
          username: username.value,
          password: password.value,
          otp: otp.value,
          ...passwordExpired.value,
        },
      });

      if (response.body.success) {
        root.$showAlertMessage(root.$t('password_expired.success_msg'));
        password.value = null;
        otp.value = null;
        clearOtpResendCountdown()
        passwordExpired.value = {};
        step.value = 1;
      }
    }

    const samlLogin = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'saml/',
        params: {},
      });

      if (response.body.auth_endpoint) {
        const endpoint = response.body.auth_endpoint;

        let tempForm = document.createElement('form');
        tempForm.setAttribute("method", "post")
        tempForm.setAttribute("action", endpoint.url)
        tempForm.setAttribute("target", "_self")

        let samlRequestField = document.createElement("input");
        samlRequestField.setAttribute("type", "text");
        samlRequestField.setAttribute("name", "SAMLRequest");
        samlRequestField.setAttribute("value", endpoint.SAMLRequest);

        let relayStateField = document.createElement("input");
        relayStateField.setAttribute("type", "text");
        relayStateField.setAttribute("name", "RelayState");
        relayStateField.setAttribute("value", window.location.pathname);

        tempForm.appendChild(samlRequestField);
        tempForm.appendChild(relayStateField);

        document.body.appendChild(tempForm);

        tempForm.submit();
      }
    }

    return {
      dialogShown,
      step,

      otp,
      otpResendAfterSeconds,
      getOtp,

      username,
      password,
      showPassword,
      login,

      passwordExpired,

      resetPassword,
      resetPasswordReEnterPasswordRules,
      submitResetPassword,

      passwordRules,
      reEnterPasswordRules,

      requiredRules,
      signup,
      showSignupPassword,
      reEnterPassword,
      showSignupReEnterPassword,

      submit,

      samlLogin,
      version: process.env.VUE_APP_VERSION,
    }
  }
}
</script>

<style lang="less">
.login-dialog {
  background-color: white;
  background-image: url('../assets/background.png');
  background-size: cover;
  background-position: top;

  .login {
    max-width: 750px;

    .login-label {
      width: 200px;
      max-width: 20vw;
    }

    .login-signup-btn {
      text-transform: none;
    }

    .login-footer {
      font-size: 60%;
    }
  }

  .signup-back-btn {
    position: absolute;
    left: 0;
    top: 0;
  }

  .version {
    position: absolute;
    right: 8px;
    bottom: 8px;
  }
}
</style>
